// @flow @jsx h

import { h, Component } from 'preact'
import styles from './Trash.css'
import { bem } from '@nrk/dh-utils'

type Props = {
  positionPercentage: number,
  index: number
}

type State = {}

class TrashLayer extends Component<Props, State> {
  render() {
    const { index, positionPercentage } = this.props

    return (
      <div
        class={styles.trash}
        style={percentageToTransfrom(positionPercentage)}
      >
        <div class={bem(styles['trash__layer'], String(index))}>
          <div class={bem(styles['trash__layer-top'], String(index))} />
          <div class={bem(styles['trash__layer-bottom'], String(index))} />
        </div>
      </div>
    )
  }
}

function percentageToTransfrom(percentage) {
  const removeEntirely = percentage > 95
  const translation = removeEntirely
    ? 105
    : Math.max(5, Math.min(percentage, 95))
  const transform = `translateY(${translation}%)`
  return {
    WebkitTransform: transform,
    transform
  }
}

export { TrashLayer }



// WEBPACK FOOTER //
// ./src/v1/components/Background/Trash.js